import Vue from "vue";
import Vuetify from "vuetify/lib";
import pt from "vuetify/es5/locale/pt";
import en from "vuetify/es5/locale/en";
import es from "vuetify/es5/locale/es";


Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: process.env.VUE_APP_COR_PRIMARIA,
        secondary: "#F0A61E",
        accent: "#8c9eff",
        error: "#b71c1c"
      }
    }
  },
  lang: {
    locales: {
      pt,
      en,
      es
    },
    current: 'pt'
  }
});



